import { useCallback } from "react";
import { SERVER_HOST } from "../../constants/config";
import { getEkycHeaders } from "../../utils/ekycHeaders";

const BaseAPIUrl = SERVER_HOST;

const useMyTenteraService = () => {

  const extractMyTenteraInfo = useCallback(
    async (params) => {
      const config = {
        headers: getEkycHeaders(),
        method: "post",
        body: params,
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mytentera-verification/extract-mytentera-info",
        config
      ).then((response) => response.json());
    },
    []
  );

  const uploadFront = useCallback(
    async (params) => {
      const config = {
        method: "post",
        headers: getEkycHeaders(),
        body: params,
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mytentera-verification/upload-front",
        config
      ).then((response) => response.json());
    },
    []
  );

  const verifyFront = useCallback(
    async (params) => {
      const config = {
        headers: getEkycHeaders({ "Content-Type": "application/json" }),
        method: "post",
        body: JSON.stringify(params),
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mytentera-verification/verify-front",
        config
      ).then((response) => response.json());
    },
    []
  );

  const uploadBack = useCallback(
    async (params) => {
      const config = {
        method: "post",
        headers: getEkycHeaders(),
        body: params,
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mytentera-verification/upload-back",
        config
      ).then((response) => response.json());
    },
    []
  );

  const verifyBack = useCallback(
    async (params) => {
      const config = {
        headers: getEkycHeaders({ "Content-Type": "application/json" }),
        method: "post",
        body: JSON.stringify(params),
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mytentera-verification/verify-back",
        config
      ).then((response) => response.json());
    },
    []
  );

  const checkResult = useCallback(
    async (params) => {
      const config = {
        headers: getEkycHeaders({ "Content-Type": "application/json" }),
        method: "post",
        body: JSON.stringify(params),
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mytentera-verification/check-result",
        config
      ).then((response) => response.json());
    },
    []
  );

  const getMyTenteraRejectReason = useCallback(
    async (params) => {
      const config = {
        headers: getEkycHeaders({ "Content-Type": "application/json" }),
        method: "post",
        body: JSON.stringify(params),
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mytentera-verification/reject-reason",
        config
      ).then((response) => response.json());
    },
    []
  );

  return {
    extractMyTenteraInfo,
    uploadFront,
    verifyFront,
    uploadBack,
    verifyBack,
    checkResult,
    getMyTenteraRejectReason,
  };
};

export { useMyTenteraService };
